import {
  Button,
  Col,
  DatePicker,
  Form,
  message,
  Modal,
  Row,
  Select,
  Spin,
  Table,
} from "antd";
import COLORS from "common/Colors";
import {
  APPROVAL_FILTER_TYPES,
  MONTH_LIST,
  STATUS_CODE,
} from "common/Constants";
import dayjs from "dayjs";
import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import {
  addMonthinDate,
  dateInDetail,
  getinitialdate,
  getKenyanDateTime,
  getMonthDateRange,
  getMySqlDate,
  momentDate,
} from "utils/Date";
import localeData from "dayjs/plugin/localeData";
import weekday from "dayjs/plugin/weekday";
import advancedFormat from "dayjs/plugin/advancedFormat";
import { CALL_API } from "common/API";
import { useSelector } from "react-redux";
import {
  getMenuList,
  getUserInfo,
  getUserList,
  getUserRoleId,
} from "redux/selectors";
import { EditOutlined, DeleteOutlined, CloseOutlined } from "@ant-design/icons";
import { ReactComponent as Edit } from "../../assets/Edit_Pencil_01.svg";
import { ReactComponent as Trash } from "../../assets/Trash_Full.svg";
import ApplyWorkFromHome from "pages/WorkFromHome/ApplyWorkFromHome";
import { ButtonFilled, ButtonOutlined } from "reusableComponent/UIButtons";
import SuccessDeclinePopup from "reusableComponent/Popup/SuccessDeclinePopup";
import ViewDocument from "reusableComponent/Popup/viewDocument";
import { find, get } from "lodash";
import download from "downloadjs";
import ViewMore from "organisms/ViewMore";
import { CSVLink } from "react-csv";

const ActionWrapper = styled.div`
  opacity: 0;
  transition: opacity 0.3s ease;
  display: flex;
  gap: 15px;
  justify-content: flex-end;

  /* Show on row hover */
  .ant-table-row:hover & {
    opacity: 1;
  }
`;

dayjs.extend(localeData);
dayjs.extend(weekday);
dayjs.extend(advancedFormat);

const ModalWrap = styled(Modal)`
  .ant-modal-content {
    border-radius: 14px;
    padding: 10px 8px;
  }

  .ant-modal-header {
    border-bottom: none;
    padding-bottom: 0;
  }

  .ant-modal-title {
    font-size: 20px;
    font-weight: 600;
    margin-top: -12px;
  }

  // .ant-modal-body {
  //   padding: 10px 20px 24px;
  // }

  /* top right icons */
  .top-icons {
    position: absolute;
    right: 55px;
    top: 18px;
    display: flex;
    gap: 18px;
    font-size: 18px;
    color: #5b6fd6;
    cursor: pointer;
  }

  .close-icon {
    position: absolute;
    right: 20px;
    top: 18px;
    font-size: 18px;
    cursor: pointer;
    color: #666;
  }

  .applied-tag {
    background: #e9ecfb;
    border-radius: 20px;
    padding: 3px 14px;
    font-size: 13px;
    margin-bottom: 18px;
    display: inline-block;
  }

  .label {
    color: #8b8b8b;
    font-weight: 500;
  }

  .value {
    color: #1f1f1f;
    font-weight: 500;
    // text-align: right;
  }

  .attachment {
    color: #2d53da;
    cursor: pointer;
  }

  .reason-title {
    margin-top: 16px;
    color: #8b8b8b;
    font-weight: 500;
  }

  .reason-text {
    margin-top: 6px;
    color: #1f1f1f;
    line-height: 1.6;
  }

  /* Responsive */
  @media (max-width: 768px) {
    .value {
      text-align: left;
      margin-top: 4px;
    }

    .top-icons {
      right: 45px;
      gap: 12px;
    }

    .ant-modal-body {
      padding: 10px 14px 22px;
    }
  }
`;

const MyWorkFromHomeWrap = styled.div`
  .ant-input::placeholder,
  .ant-picker-input > input::placeholder {
    color: #9ca3af !important;
  }

  .ant-select-selection-placeholder {
    color: #9ca3af !important;
  }

  .ant-input,
  .ant-picker,
  .ant-select-selector,
  .ant-btn {
    border-radius: 24px !important;
  }

  .ant-btn {
    width: 100%;
  }
`;

const StyledTable = styled(Table)`
  .ant-table {
    border: 1px solid #ccc;
    border-radius: 12px;
    overflow: hidden;
  }

  .ant-table-container {
    border-radius: 12px;
  }

  .ant-table-content {
    overflow-x: auto;
  }

  table {
    width: 100%;
    min-width: 900px;
  }

  .ant-table-cell {
    padding: 16px;
    white-space: wrap;
    overflow: hidden;
  }

  .ant-table-thead .ant-table-cell {
    font-weight: 600;
    color: ${COLORS.SECONDARY_BLACK};
  }

  .reason-column {
    min-width: 280px;
    white-space: normal;
  }

  .non-white {
    background: #f9f9f9;
  }

  @media (max-width: 768px) {
    .ant-table-cell {
      padding: 10px;
      font-size: 12px;
    }
  }
`;

const wfh = {
  appliedDate: "22nd Mar, 2024",
  startDate: "05th Aug 2024 - Tue",
  endDate: "05th Aug 2024 - Tue",
  totalDays: 1,
  attachment: "Attachment.png",
  reason:
    "I have some important personal occasions on the specified dates. Kindly excuse my absence. I will make sure to resume my duty once I am back.",
};

const MyWorkFromHome = () => {
  const [form] = Form.useForm();
  const containerRef = useRef(null);
  const userInfo = useSelector(getUserInfo);
  const menuList = useSelector(getMenuList);
  const userRoleId = useSelector(getUserRoleId);
  const Menulist = menuList[userRoleId] || Object.values(menuList)[0];
  const durationType = Form.useWatch("duration_type", form);
  const statusType = Form.useWatch("status", form);
  const pageTitleRef = useRef(null);
  const [data, setData] = useState([]);
  const [viewData, setViewData] = useState([]);
  const [open, setOpen] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isDelete, setIsDelete] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [popupOpen, setPopupOpen] = useState(false);
  const [preview, setPreview] = useState(false);
  const [previewURL, setPreviewURL] = useState();
  const [CSVDataList, setCSVDataList] = useState([]);
  const csvLinkEl = useRef();

  const prepareCSV = async (event, done) => {
    if (data?.length > 0) {
      const csvData = data.map((item) => {
        const baseObj = {
          "Start Date": item?.wfhStartDate
            ? dayjs(item.wfhStartDate).format("Do MMM YYYY - ddd")
            : "-",
          "End Date": item?.wfhEndDate
            ? dayjs(item.wfhEndDate).format("Do MMM YYYY - ddd")
            : "-",
          "Total Days": item?.wfhNoofDays || "-",
          "Applied on": item?.createdAt
            ? dayjs(item.createdAt).format("Do MMM YYYY - ddd")
            : "-",
          "Reason for WFH": item?.wfhReason || "-",
        };

        if (statusType === "1") {
          baseObj["Approved by"] = item?.approved_rejected_byName || "-";
        }

        if (statusType === "2") {
          baseObj["Rejected by"] = item?.approved_rejected_byName || "-";
          baseObj["Decline Reason"] = item?.rejectReason || "-";
        }

        return baseObj;
      });

      setCSVDataList(csvData);

      setTimeout(() => {
        csvLinkEl.current.link.click();
      });
    } else {
      message.error("No data available to download.");
    }
  };

  const [scrollY, setScrollY] = useState(120);

  function weeks(days, date) {
    var date = new Date(date);
    date.setDate(date.getDate() + days);
    return date.toISOString().slice(0, 10);
  }

  const getData = async () => {
    const { start_date, duration_type, month, end_date } =
      form.getFieldsValue();
    const { startDateOfMonth, lastDateOfMonth } = getMonthDateRange(
      dateInDetail(getKenyanDateTime()).year,
      get(
        find(MONTH_LIST, { value: month || dayjs().format("MMMM") }),
        "index",
        0
      )
    );
    const status = form.getFieldValue("status");

    const startDate = getMySqlDate(
      duration_type === 2
        ? startDateOfMonth
        : duration_type === 4
        ? momentDate(addMonthinDate(getinitialdate()))
        : dayjs(start_date).format("YYYY-MM-DD")
    );
    const endDate = getMySqlDate(
      duration_type === 2
        ? lastDateOfMonth
        : duration_type === 3
        ? weeks(7, getMySqlDate(start_date))
        : duration_type === 4
        ? momentDate(addMonthinDate(getKenyanDateTime(), 3))
        : dayjs(end_date).format("YYYY-MM-DD")
    );
    setLoading(true);
    const { code, data } = await CALL_API(
      `employeerequest/wfhrequest?userId=${userInfo?.userid}&statusId=${status}&startDate=${startDate}&endDate=${endDate}`,
      "get"
    );
    if (code === "SUCCESS") {
      const mapped = (data || []).map((item) => ({
        ...item,
        wfhStartDate: item?.startDate,
        wfhEndDate: item?.endDate,
        wfhNoofDays: item?.noOfDays,
        wfhReason: item?.reason,
        approved_rejected_byName: item?.approved_rejected_byName || item?.officesupervisor?.trim() || "",
        rejectReason: typeof item?.requestType === "object" ? item?.requestType?.decline_reason || "" : "",
      }));
      setData(mapped);
      setLoading(false);
    }
  };

  useEffect(() => {
    getData();
  }, [form, userInfo]);

  const handleOk = async () => {
    setDeleteLoading(true);
    const { code, data } = await CALL_API(
      `employeerequest/${userInfo?.userid}/${
        viewData?.requestId
      }?requestType=${"wfhrequest"}`,
      "delete"
    );
    if (code === STATUS_CODE.SUCCESS) {
      setIsDelete(false);
      setViewData({});
      setDeleteLoading(false);
      setPopupOpen(true);
      setTimeout(() => {
        setPopupOpen(false);
      }, 2000);
      getData();
    } else {
      message.error("something went wrong");
    }
  };

  const handlePreviewClick = async (data) => {
    try {
      const preview = data?.fileName?.split(".")?.pop();
      setLoading(true);

      const { code, url } = await CALL_API(
        `employeerequest/file?userId=${data?.userId}&requestId=${
          data?.requestId
        }&requestType=${"wfhrequest"}`,
        "get",
        {}
      );

      if (code === STATUS_CODE.SUCCESS) {
        if (["jpg", "jpeg", "png", "svg", "pdf"].includes(preview)) {
          setPreviewURL(url);
          setPreview(true);
        } else {
          download(url);
          setPreview(false);
        }
      } else {
        message.error("Preview failed. Try again.");
      }
    } catch (err) {
      console.error(err);
      message.error("Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!pageTitleRef.current) return;

    const baseOffset = 300;
    const minHeight = 120;

    const calculateScrollY = () => {
      const headerHeight = pageTitleRef.current.offsetHeight;

      const availableHeight = window.innerHeight - headerHeight - baseOffset;

      setScrollY(Math.max(minHeight, availableHeight));
    };

    calculateScrollY();

    const resizeObserver = new ResizeObserver(() => {
      calculateScrollY();
    });

    resizeObserver.observe(pageTitleRef.current);
    window.addEventListener("resize", calculateScrollY);

    return () => {
      resizeObserver.disconnect();
      window.removeEventListener("resize", calculateScrollY);
    };
  }, []);

  const columns = [
    {
      title: "Start Date - Day",
      dataIndex: "wfhStartDate",
      key: "wfhStartDate",
      width: 150,
      render: (date) => {
        return dayjs(date)?.format("Do MMM YYYY - ddd");
      },
    },
    {
      title: "End Date - Day",
      dataIndex: "wfhEndDate",
      key: "wfhEndDate",
      width: 150,
      render: (date) => {
        return dayjs(date)?.format("Do MMM YYYY - ddd");
      },
    },
    {
      title: "Total Days",
      dataIndex: "wfhNoofDays",
      key: "wfhNoofDays",
      width: 150,
    },
    {
      title: "Applied on",
      dataIndex: "createdAt",
      key: "createdAt",
      width: 150,
      render: (date) => {
        return dayjs(date)?.format("Do MMM YYYY - ddd");
      },
    },
    {
      title: "Attachment",
      dataIndex: "fileName",
      key: "fileName",
      width: 150,
      render: (text, record) =>
        text ? (
          <a
            className="text-wrap"
            href="#"
            style={{ color: "#2d53da" }}
            onClick={(e) => {
              e.stopPropagation();
              handlePreviewClick(record);
            }}
          >
            {text}
          </a>
        ) : (
          "-"
        ),
    },

    {
      title: "Reason for WFH",
      dataIndex: "wfhReason",
      key: "wfhReason",
      width: 150,
      className: "reason-column",
    },
    {
      key: "actions",
      width: 100,
      // fixed: "right",
      render: (_, record) => {
        return (
          <ActionWrapper>
            <div className="top-icons ">
              {record?.statusId === "0" && (
                <>
                  {Menulist?.find(
                    (item) => item?.key === "wfhreq" && item?.permission.edit
                  ) && (
                    <Edit
                      style={{ cursor: "pointer" }}
                      onClick={(e) => {
                        e.stopPropagation();
                        setIsEdit(true);
                        setViewData(record);
                      }}
                    />
                  )}
                  {Menulist?.find(
                    (item) => item?.key === "wfhreq" && item?.permission.delete
                  ) && (
                    <Trash
                      style={{ cursor: "pointer" }}
                      onClick={(e) => {
                        e.stopPropagation();
                        setIsDelete(true);
                        setViewData(record);
                      }}
                    />
                  )}
                </>
              )}
            </div>
          </ActionWrapper>
        );
      },
    },
  ];

  if (statusType === "1") {
    columns.push({
      title: "Approved by",
      dataIndex: "approved_rejected_byName",
      key: "approved_rejected_byName",
      width: 150,
      render: (text) => {
        return text ? text : "-";
      },
    });
  }
  if (statusType === "2") {
    columns.push(
      {
        title: "Rejected by",
        dataIndex: "approved_rejected_byName",
        key: "approved_rejected_byName",
        width: 150,
        render: (text) => {
          return text ? text : "-";
        },
      },
      {
        title: "Decline Reason",
        dataIndex: "rejectReason",
        key: "rejectReason",
        width: 150,
        className: "normal-column",
        render: (reason) => {
          return (
            <>
              <ViewMore value={reason || "-"} />
            </>
          );
        },
      }
    );
  }

  const validateDateRange = () => {
    const endDate = dayjs(form.getFieldValue("end_date"));
    const startDate = dayjs(form.getFieldValue("start_date"));
    if (dayjs(startDate).isAfter(endDate)) {
      form.setFieldsValue({
        end_date: startDate,
      });
      getData();
    }
  };

  const validateEndDateRange = () => {
    const startDate = dayjs(form.getFieldValue("start_date"));
    const endDate = dayjs(form.getFieldValue("end_date"));
    if (dayjs(endDate).isBefore(startDate)) {
      form.setFieldsValue({
        start_date: endDate,
      });
      getData();
    }
  };

  return (
    <MyWorkFromHomeWrap>
      <div className="page-title" ref={pageTitleRef}>
        <Form
          form={form}
          layout="vertical"
          initialValues={{
            status: "0",
            duration_type: 4,
            month: dateInDetail(getKenyanDateTime()).monthName,
            status_id: "4",
            start_date: dayjs(),
            end_date: dayjs(),
          }}
          onValuesChange={getData}
        >
          <Row gutter={16}>
            <Col xs={24} sm={12} md={8} lg={4} ref={containerRef}>
              <Form.Item name="status">
                <Select
                  placeholder="Status"
                  options={[
                    { label: "Waiting For Approval", value: "0" },
                    { label: "Approved", value: "1" },
                    { label: "Rejected", value: "2" },
                  ]}
                  getPopupContainer={() => containerRef.current}
                />
              </Form.Item>
            </Col>

            <Col xs={24} sm={12} md={8} lg={4} ref={containerRef}>
              <Form.Item name="duration_type">
                <Select
                  placeholder="Select..."
                  options={APPROVAL_FILTER_TYPES}
                  getPopupContainer={() => containerRef.current}
                />
              </Form.Item>
            </Col>

            {durationType === 1 && (
              <>
                <Col xs={24} sm={12} md={8} lg={4} ref={containerRef}>
                  <Form.Item name="start_date">
                    <DatePicker
                      placeholder="Start date"
                      format="DD-MM-YYYY"
                      className="w-100"
                      allowClear
                      onChange={validateDateRange}
                      getPopupContainer={() => containerRef.current}
                    />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={12} md={8} lg={4} ref={containerRef}>
                  <Form.Item name="end_date">
                    <DatePicker
                      className="w-100"
                      placeholder="End date"
                      format="DD-MM-YYYY"
                      allowClear
                      onChange={validateEndDateRange}
                      getPopupContainer={() => containerRef.current}
                    />
                  </Form.Item>
                </Col>
              </>
            )}

            {durationType === 2 && (
              <Col xs={24} sm={12} md={8} lg={4} ref={containerRef}>
                <Form.Item name="month">
                  <Select
                    placeholder="Select..."
                    options={MONTH_LIST}
                    getPopupContainer={() => containerRef.current}
                  />
                </Form.Item>
              </Col>
            )}
            <Col
              xs={24}
              sm={12}
              md={8}
              lg={durationType === 1 ? 8 : durationType === 2 ? 12 : 16}
              className="text-end"
            >
              <ButtonOutlined
                className="mt-0"
                style={{ borderRadius: "2px !important", width: "150px" }}
                onClick={prepareCSV}
                disabled={data.length === 0}
              >
                Export CSV file
              </ButtonOutlined>
              <CSVLink
                data={CSVDataList}
                filename={"workfromhome.csv"}
                asyncOnClick={true}
                ref={csvLinkEl}
              />
            </Col>
          </Row>
        </Form>
      </div>
      <Spin spinning={loading}>
        <StyledTable
          columns={columns}
          dataSource={data}
          pagination={false}
          scroll={{ y: scrollY }}
          style={{ minHeight: scrollY + 50 }}
          rowClassName={(_, index) => (index % 2 ? "non-white" : "")}
          onRow={(record) => {
            return {
              onClick: (e) => {
                e.stopPropagation();
                setOpen(true);
                setViewData(record);
              },
            };
          }}
        />
      </Spin>
      <ModalWrap
        open={open}
        onCancel={() => {
          setOpen(false);
          setViewData({});
        }}
        footer={null}
        centered
        width={520}
        closable={false}
        title="WFH Request"
      >
        {/* top icons */}
        {viewData?.statusId === "0" && (
          <div className="top-icons">
            <Edit
              onClick={(e) => {
                e.stopPropagation();
                setOpen(false);
                setIsEdit(true);
              }}
            />

            <Trash
              onClick={(e) => {
                e.stopPropagation();
                setOpen(false);
                setIsDelete(true);
              }}
            />
          </div>
        )}

        <CloseOutlined
          className="close-icon"
          onClick={() => {
            setOpen(false);
            setViewData({});
          }}
        />

        {/* applied tag */}
        <div className="applied-tag">
          Applied on&nbsp;&nbsp;
          <b className="value">
            {dayjs(viewData?.createdAt).format("Do MMM, YYYY")}
          </b>
        </div>

        {/* start date */}
        <Row gutter={[8, 14]}>
          <Col xs={24} sm={12}>
            <div className="label">Start Date</div>
          </Col>
          <Col xs={24} sm={12}>
            <div className="value">
              {dayjs(viewData?.wfhStartDate)?.format("Do MMM YYYY - ddd")}
            </div>
          </Col>

          {/* end date */}
          <Col xs={24} sm={12}>
            <div className="label">End Date</div>
          </Col>
          <Col xs={24} sm={12}>
            <div className="value">
              {dayjs(viewData?.wfhEndDate)?.format("Do MMM YYYY - ddd")}
            </div>
          </Col>

          {/* total days */}
          <Col xs={24} sm={12}>
            <div className="label">Total Days</div>
          </Col>
          <Col xs={24} sm={12}>
            <div className="value">{viewData?.wfhNoofDays}</div>
          </Col>

          {/* attachment */}
          <Col xs={24} sm={12}>
            <div className="label">Attachment</div>
          </Col>
          <Col xs={24} sm={12}>
            <div
              className="value attachment"
              style={{ cursor: "pointer" }}
              onClick={() => {
                setOpen(false);
                handlePreviewClick(viewData);
              }}
            >
              {viewData?.fileName ? viewData?.fileName : "-"}
            </div>
          </Col>
        </Row>

        {/* reason */}
        <div className="reason-title">Reason for WFH</div>
        <div className="reason-text">{viewData?.wfhReason}</div>
      </ModalWrap>
      <ApplyWorkFromHome
        open={isEdit}
        onCancel={() => {
          setIsEdit(false);
          setViewData([]);
        }}
        data={viewData}
        getData={getData}
      />
      <Modal
        open={isDelete}
        footer={null}
        centered
        closable={false}
        width={420}
        onCancel={() => {
          setIsDelete(false);
          setViewData({});
        }}
      >
        <div className="delete-text">
          Are you sure you want to delete this work form home request?
        </div>

        <div className="w-100 text-end mt-3">
          <ButtonOutlined
            onClick={() => {
              setIsDelete(false);
              setViewData({});
            }}
          >
            Cancel
          </ButtonOutlined>

          <ButtonFilled onClick={handleOk} loading={deleteLoading}>
            Delete
          </ButtonFilled>
        </div>
      </Modal>
      <SuccessDeclinePopup
        open={popupOpen}
        setOpen={setPopupOpen}
        type={"success"}
        message={"Deleted"}
      />
      <ViewDocument
        open={preview}
        onCancel={() => {
          setPreview(false);
          setPreviewURL("");
        }}
        data={previewURL}
      />
    </MyWorkFromHomeWrap>
  );
};

export default MyWorkFromHome;